export const ANDROID_BANNER_CLOSE_TRACKING = 'Touch - Close on Mobile Banner'
export const ANDROID_BANNER_GET_TRACKING = 'Touch - Get on Mobile Banner'
export const ANDROID_BANNER_SHOW_TRACKING = 'Show - Mobile Banner'
export const ANDROID_BANNER_EVENT_PROPERTIES = { platformType: 'Android' }

export const LOGIN_ATTEMPT_TRACKING = 'Login - Failed Attempt'
